import React from "react";
import { Label, Input } from "reactstrap";

const RegionsDropdown = ({
  value,
  onChange,
  label = "Region",
  className = "",
  regionList,
}) => {
  return (
    <div className={`col-md-12 col-sm-12 ${className}`}>
      <Label>{label}</Label>
      <Input
        type="select"
        name="select"
        className="form-control digits uiStyleDashboard"
        value={value}
        onChange={onChange}
      >
        <option value="">Select</option>
        {[{ label: "All", value: "all" }, ...regionList].map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </Input>
    </div>
  );
};

export default RegionsDropdown;
